module.exports = __webpack_public_path__ + "static/media/flooring_material_60y_n.57dd23a1.csv";